import { Link } from 'react-router';
import { Layout } from '../components/Layout.js';
import { es } from '../i18n/es.js';

export function NotFoundPage() {
  return (
    <Layout center>
      <section className="flex flex-col gap-6">
        <p className="font-mono text-sm text-neutral-500 dark:text-neutral-400">
          {es.notFound.code}
        </p>
        <div className="flex flex-col gap-3">
          <h1 className="text-3xl font-semibold leading-tight tracking-tight">
            {es.notFound.title}
          </h1>
          <p className="text-base leading-relaxed text-neutral-600 dark:text-neutral-400">
            {es.notFound.body}
          </p>
        </div>
        <Link
          to="/"
          className="inline-flex min-h-11 items-center self-start rounded-md bg-accent px-4 text-sm font-medium text-white hover:bg-accent-strong"
        >
          {es.notFound.goHome}
        </Link>
      </section>
    </Layout>
  );
}
